import { Text, Tooltip } from '@chakra-ui/react'

export const EllipsisText = ({
  text,
  maxWidth,
  withTooltip,
}: {
  text: string
  maxWidth?: number
  withTooltip?: boolean
}) => {
  const content = (
    <Text maxW={maxWidth} px={1} whiteSpace="nowrap" textOverflow="ellipsis" overflow="hidden">
      {text && text !== 'zzz' ? text : 'None'}
    </Text>
  )
  return withTooltip ? (
    <Tooltip placement="top" hasArrow label={text}>
      {content}
    </Tooltip>
  ) : (
    content
  )
}
